import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "walk"
const WalkIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M9.355 6.572C10.34 6.398 11.353 6.457 12.31 6.746 13.191 7.01 14 7.464 14.687 8.069L14.827 8.19Q14.887 8.244 14.941 8.306L14.945 8.311 14.956 8.323Q15.014 8.386 15.06 8.447L16.473 10.173 18.11 11.158C18.942 11.658 19.245 12.702 18.84 13.562L18.75 13.73C18.25 14.562 17.206 14.866 16.346 14.46L16.177 14.372 14.347 13.27 14.122 14.17 15.879 16.12V16.123L16.05 16.31 16.131 16.404 16.167 16.524 17.366 20.516C17.615 21.352 17.187 22.232 16.397 22.559L16.233 22.617C15.341 22.884 14.401 22.377 14.133 21.486L13.116 18.099 11.543 16.35 9.176 13.59 9.072 13.47 9.047 13.312C8.997 13 9.019 12.668 9.127 12.343L9.803 10.31C9.473 10.397 9.162 10.546 8.888 10.751 8.558 11 8.288 11.321 8.106 11.691 7.646 12.619 6.522 13 5.594 12.54S4.287 10.958 4.744 10.03C5.189 9.133 5.839 8.352 6.639 7.75 7.438 7.151 8.369 6.747 9.355 6.572M11.987 7.822C11.197 7.584 10.363 7.536 9.55 7.68 8.739 7.823 7.973 8.156 7.313 8.651 6.653 9.145 6.118 9.789 5.753 10.528 5.57 10.899 5.723 11.349 6.093 11.533 6.464 11.716 6.913 11.563 7.097 11.193 7.36 10.664 7.742 10.205 8.213 9.852 8.683 9.498 9.233 9.26 9.813 9.157Q10.225 9.085 10.636 9.104L11.38 9.137 10.194 12.699Q10.145 12.848 10.148 12.996L12.379 15.598 14.122 17.534 14.158 17.655 15.21 21.162C15.3 21.459 15.613 21.628 15.91 21.539S16.376 21.137 16.288 20.84L15.126 16.968 13.086 14.7 12.886 14.478 13.756 10.997 14.648 12.089 14.73 12.187 14.843 12.257H14.844L16.757 13.407C17.112 13.62 17.573 13.505 17.787 13.151 17.998 12.796 17.883 12.335 17.53 12.12L15.81 11.088 15.728 11.037 15.665 10.96 14.177 9.143Q14.148 9.104 14.125 9.079L14.117 9.072 14.11 9.064Q14.06 9.006 14.002 8.963L13.986 8.949 13.969 8.936C13.398 8.425 12.722 8.044 11.988 7.822"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M11.37 17.887 10.863 19.204 10.821 19.316 10.736 19.401 10.566 19.57 7.943 22.194C7.284 22.852 6.215 22.853 5.556 22.194 4.897 21.534 4.898 20.466 5.556 19.808L7.925 17.437 8.806 15.149zM8.933 17.952 8.891 18.063 6.35 20.603C6.133 20.823 6.133 21.179 6.352 21.398 6.572 21.618 6.928 21.618 7.148 21.398L9.773 18.773 9.856 18.689 9.9 18.578 10.066 18.14 9.212 17.23zM14.25 1.313C15.596 1.313 16.688 2.403 16.688 3.75S15.596 6.188 14.25 6.188 11.813 5.095 11.813 3.75 12.903 1.313 14.25 1.313M14.25 2.438C13.525 2.438 12.938 3.024 12.938 3.75S13.525 5.062 14.25 5.063 15.563 4.475 15.563 3.75 14.975 2.438 14.25 2.438"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default WalkIcon
